

(function($, window, document) {

    // The $ is now locally scoped 
    
    if(typeof Number.prototype.pad2 !== "function"){
        Number.prototype.pad2 = function(){
            return 10>this?"0"+this:""+this
        }
    } 

    if (!String.prototype.trim) {
        String.prototype.trim = function () {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        };
    }

    


    function is_ie() {

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
        {
            return true;
        }
        else  // If another browser, return 0
        {
            return false;
        }

        return false;
    }


    function is_mozilla() {

        if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
            return true;
        }

        return false;
    }




    function isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    function strInsert(main_string, ins_string, pos) {
        if(typeof(pos) == "undefined" || typeof(ins_string) == "undefined" || main_string.length <= pos) {
            return main_string
        } 

        return main_string.slice(0, main_string.length - pos) + ins_string + main_string.slice( main_string.length - pos);
    }



    //  COOKIES

    function createCookie(name, value, days) {
        if(days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          var expires = "; expires=" + date.toGMTString();
        } else var expires = "";
        document.cookie = name + "=" + value + expires + "; path=/"
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
         
        }
        return null;
    }

    function eraseCookie(name) {
        createCookie(name, "", -1);
    }







    var target = window.location.search;
    var hasSearch = ((target[0] == '?') || (window.location.href[window.location.href.length - 1] == '?'));

    target = target.replace('?', '');


    var targets = target.split("&");
    for(var i = 0; i < targets.length; i++){
        // if(targets[i].split("=")[0] == "solucao_id"){
            

        //     window.history.pushState(null, null, window.location.href.replace(window.location.search, "")); 
        // }
    }



    var vars_GET = window.location.search.slice(1).split('&').reduce(function _reduce (/*Object*/ a, /*String*/ b) {
                                                                        b = b.split('=');
                                                                        a[b[0]] = decodeURIComponent(b[1]);
                                                                        return a;
                                                                    }, {}
                                                                );
    if(vars_GET.login && vars_GET.message){
        // $('#lp-login-modal').modal('show')
        // window.history.pushState(null, null, window.location.href.replace(window.location.search, "")); 
    }else if (vars_GET.open_login) {
        // $('#lp-login-modal').modal('show')
        
    }

    
    var location_href = $(location).attr('href');
    if (location_href.indexOf("#") >= 0) {

        var scrTop = ($('#'+(location_href.split('#')[1])).offset().top - $('header.lp-header').innerHeight() );
        var root = $('html, body');

        root.animate({scrollTop: parseInt(scrTop)}, 600);

        $('.lp-header-menu-close').removeClass('active');
        $('.lp-header-menu-button').removeClass('active');
        $('.lp-header-modal-menu-button').removeClass('active');
        $('.lp-header-nav').removeClass('active');
        $('.lp-header-menu-button svg').removeClass('active');
        $('body').removeClass('menu-open');

    }



    /*Anchor scroll*/
    $('a[href*="#"]').click(function(e) {
        var link = this.href;
        
        if (link.indexOf("#") >= 0) {
            var location_href = $(location).attr('href');

            if(location_href.split('#')[0] == link.split('#')[0]){
                e.preventDefault();

                var scrTop = ($('#'+(link.split('#')[1])).offset().top - $('header.lp-header').innerHeight() );
                var root = $('html, body');

                root.animate({scrollTop: parseInt(scrTop)}, 150);


                $('.lp-header-menu-close').removeClass('active');
                $('.lp-header-menu-button').removeClass('active');
                $('.lp-header-modal-menu-button').removeClass('active');
                $('.lp-header-nav').removeClass('active');
                $('.lp-header-menu-button svg').removeClass('active');
                $('body').removeClass('menu-open');
            }

        }

    });




    $(window).scroll(function(event) {
        let window_sc_top = $(window).scrollTop();
        let window_i_height = window.innerHeight;

        if(window_sc_top > 5){
            $('body').addClass('no-top');
        }else{
            $('body').removeClass('no-top');
        }

        if(window_sc_top > ($(window).innerHeight() / 2)){
            $('body').addClass('scrolled');
        }else{
            $('body').removeClass('scrolled');
        }

        $(".lp-counters").each(function(index, el) {
            if($(el).offset().top < (window_sc_top + (window_i_height * 0.6))){
                $(el).find('.counters-item').each(function(index, el_item) {
                    let num_el = $(el_item).find('.num');
                    if(num_el.length > 0){

                        increment_numbers(
                                            num_el[0],
                                            $(el_item).data('value'),
                                            $(el_item).data('before'),
                                            $(el_item).data('after'),
                                            $(el).data('time')
                                        );
                    }
                });
            }
        });
        
    });

    $(window).trigger('scroll');



    $('.lp-header-menu-button').click(function(event) {
        if($(this).hasClass('active')){
            $(this).removeClass('active');
            $('.lp-header-menu-close').removeClass('active');
            $('.lp-header-nav').removeClass('active');
            $(this).find('svg').removeClass('active');
            $('body').removeClass('menu-open');
        }else{

            $(this).addClass('active');
            $('.lp-header-menu-close').addClass('active');
            $('.lp-header-nav').addClass('active');
            $(this).find('svg').addClass('active');
            $('body').addClass('menu-open');
        }
    });

    $('.lp-header-menu-close, .lp-header-menu-btn-close').click(function(event) {
        $('.lp-header-menu-close').removeClass('active');
        $('.lp-header-menu-button').removeClass('active');
        $('.lp-header-nav').removeClass('active');
        $('.lp-header-menu-button svg').removeClass('active');
        $('body').removeClass('menu-open');
    });


    $('.lp-header-modal-menu .modal-menu-close, .lp-header-modal-menu .modal-menu-close-area').click(function(event) {
        $('.lp-header-modal-menu-button').removeClass('active');
        $('.lp-header-modal-menu').removeClass('active');
    });




    window.addEventListener('resize', function(event){

        

        if($(window).innerWidth() > 990){


            $('.lp-header-menu-close').removeClass('active');
            $('.lp-header-menu-button').removeClass('active');
            $('.lp-header-nav').removeClass('active');
            $('.lp-header-menu-button svg').removeClass('active');
            $('body').removeClass('menu-open');
        }else{

        }




        if($(window).innerWidth() > 767){

        }else{

          

        }
        
    });



    if($(window).innerWidth() > 767){

       
    }else{


    }

    



    $(document).click(function(event) { 
        var target = $(event.target);
        if(($(target).parents('.-form-group.open').length < 1)){
            setTimeout(function(){
                $('.select.open').removeClass('open');
            },5);
        }

    });






    //Function  Mask
    function mask(o, f) {
        setTimeout(function () {
            var v = f(o.value);
            if (v != o.value) {
                o.value = v;
            }
        }, 1);
    }

    function mphone(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
        v = v.replace(/(\d)(\d{4})$/, "$1-$2");
        return v;
    }

    function mcep(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{5})(\d{3})?/, "$1-$2");
        if(v[v.length - 1] == '-'){
            v = v.slice(0, v.length - 1);
        }   
        return v;
    }

    function mvalue(v) {
        
            v = v.replace(/\D/g, "");
            // v = parseInt(v);
            var position = 6;
            if(parseInt(v) > 0){
                v = String(v);
                while(v.length < 3){
                    v = '0'+v;
                }
                while(v.length > 3 && v[0] == '0'){
                    v = v.slice(1,v.length);
                }

                v = v.slice(0, v.length - 2)+','+v.slice(v.length - 2,v.length);
                while(position < v.length){
                    v = v.slice(0, v.length - position)+'.'+v.slice(v.length - position,v.length);
                    position = position + 4;
                }
            }else{
                v='';
            }
            return v;
    }

    function mnum(v) {
        v = v.replace(/\D/g, "");
        return v;
    }

    function memail(v) {
        v = v.replace(/[()+=#%!{}\[\];:,<>?/\|""''&*°\\/´`~^$¨]/g, "");
        var parts = v.split('@');
        v = "";
        for(var i = 0; i < parts.length; i++){
            if(i == 1){
                v += "@";
            }
            v += parts[i];
        }
        
        return v;
    }


    function mCNPJ(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1.$2.$3/$4-$5");
        while(v[v.length - 1] == '-' || v[v.length - 1] == '/' || v[v.length - 1] == '.'){
            v = v.substring(0, v.length - 1);
        }
        return v;
    }

    function mCPF(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{3})(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4");
        while(v[v.length - 1] == '-' || v[v.length - 1] == '/' || v[v.length - 1] == '.'){
            v = v.substring(0, v.length - 1);
        }
        return v;
    }

    function mRG(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4");
        
        return v;
    }

    function mtext(v) {
        v = v.replace(/[0123456789()_+-=#@%!{}\[\];:,<>?/\|""''&*°\\/´`~^$¨]/g, "");
        return v;
    }

    $('input[type="tel"],.mask-tel').keypress(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').keypress(function() {
        mask(this, memail);
    });


    $('input.mask-cep').keypress(function() {
        mask(this, mcep);
    });

    $('input.mask-value').keypress(function() {
        mask(this, mvalue);
    });

    $('input.mask-num').keypress(function() {
        mask(this, mnum);
    });

    $('input.mask-text').keypress(function() {
        mask(this, mtext);
    });

    $('input.mask-cpf').keypress(function() {
        mask(this, mCPF);
    });

    $('input.mask-cnpj').keypress(function() {
        mask(this, mCNPJ);
    });


    $('input[type="tel"],.mask-tel').change(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').change(function() {
        mask(this, memail);
    });


    $('input.mask-cep').change(function() {
        mask(this, mcep);
    });

    $('input.mask-value').change(function() {
        mask(this, mvalue);
    });

    $('input.mask-num').change(function() {
        mask(this, mnum);
    });

    $('input.mask-text').change(function() {
        mask(this, mtext);
    });

    $('input.mask-cpf').change(function() {
        mask(this, mCPF);
    });

    $('input.mask-cnpj').change(function() {
        mask(this, mCNPJ);
    });



    $('input[type="tel"],.mask-tel').keyup(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').keyup(function() {
        mask(this, memail);
    });


    $('input.mask-cep').keyup(function() {
        mask(this, mcep);
    });

    $('input.mask-value').keyup(function() {
        mask(this, mvalue);
    });

    $('input.mask-num').keyup(function() {
        mask(this, mnum);
    });

    $('input.mask-text').keyup(function() {
        mask(this, mtext);
    });

    $('input.mask-cpf').keyup(function() {
        mask(this, mCPF);
    });

    $('input.mask-cnpj').keyup(function() {
        mask(this, mCNPJ);
    });


    $(".mask-cpf-cnpj").keydown(function(event){
        if(event.keyCode == 8){

            var v = this.value.trim();
            v = v.replace(/\./g, '');
            v = v.replace('-', '');
            v = v.replace('/', ''); 
            v = v.replace('.', ''); 

            if(v.length < 13){

                mask(this, mCPF);
            }else{

                mask(this, mCNPJ);
            }
        }

    });


    $(".mask-cpf-cnpj").keypress(function(){

        var v = this.value.trim();
        v = v.replace(/\./g, '');
        v = v.replace('-', '');
        v = v.replace('/', ''); 
        v = v.replace('.', ''); 

        if(v.length < 11){

            mask(this, mCPF);
        }else{

            mask(this, mCNPJ);
        }

    });


    $(".mask-cpf-cnpj").change(function(event ){


        var v = this.value.trim();
        v = v.replace(/\./g, '');
        v = v.replace('-', '');
        v = v.replace('/', ''); 
        v = v.replace('.', ''); 


        if(v.length < 12){

            mask(this, mCPF);
        }else{

            mask(this, mCNPJ);
        }
        

    });


    $(".mask-cpf-cnpj").each(function(index, el){
        var v = this.value.trim();
        v = v.replace(/\./g, '');
        v = v.replace('-', '');
        v = v.replace('/', ''); 
        v = v.split('');

        if(v.length < 12){

            mask(el, mCPF);
        }else{

            mask(el, mCNPJ);
        }
    });


    $('input.mask-cpf').each(function(index, el){
        mask(el, mCPF);
    });
    $('input.mask-cnpj').each(function(index, el){
        mask(el, mCNPJ);
        
    });
    $('input[type="tel"],.mask-tel').each(function(index, el) {
        mask(el, mphone);
    });
    $('input.mask-cep').each(function(index, el) {
        mask(el, mcep);
    });




    function onlyUnique(value, index, array) {
      return array.indexOf(value) === index;
    }





    // Set recaptcha token to input
    if(typeof grecaptcha !== 'undefined') {
        var last_recaptcha_time = (new Date).getTime();
        grecaptcha.ready(function() {
            // grecaptcha.execute(wpcf7_recaptcha.sitekey, {action: 'submit'}).then(function(token) {
            //     var i = $('input.lp-g-recaptcha-t');
    
            //     if(i.val() == '') i.val(token);
            // });
        });

        $('html, input, select, textarea').on('change keyup blur click focus hover keypress keydown',function(event) {
            let new_recaptcha_time = (new Date).getTime();
            if(new_recaptcha_time - last_recaptcha_time > (1000*60*2)){
                last_recaptcha_time = new_recaptcha_time;

                // grecaptcha.execute(wpcf7_recaptcha.sitekey, {action: 'submit'}).then(function(token) {
                //     var i = $('input.lp-g-recaptcha-t');
        
                //     i.val(token);

                // });
            }
        });
    }



    $("form:not(.no-validate) select").each(function(index, el) {
        var option = $(el).find('option')[0];
        if(option){
            if(option.value == '' || $(el).hasClass('select-first-empty')){
                option.value = '';
                $(option).attr({
                    disabled: 'true',
                    selectec: 'true'
                });
            } 

        }

        $(this).change(function(event) {
            $(this).addClass('changed');
        });
    });


    // $("form:not(.no-validate)").submit(function(event) {
    $("form").submit(function(event) {

        let is_cf7 = $(this).hasClass('wpcf7-form');

        if(is_cf7){

            $(this).find('input[type=submit]').attr({ disabled: '' });
            $(this).addClass('loading');
        }

        // var inputs = $(this).find('input:not(.no-validate)');
        // var textareas = $(this).find('textarea:not(.no-validate)');
        // var selects = $(this).find('select:not(.no-validate)');

        var inputs = $(this).find('input');
        var textareas = $(this).find('textarea');
        var selects = $(this).find('select');

        var error = false;

        inputs.each(function(index, el) {

            if($(el).hasClass('.no-validate') || $(el).parents('.no-validate').length > 0){

            }else{

                if($(el).parents('.form-change-password').length < 1 || $(el).parents('.form-change-password').find('.change-password').is(':checked')){

                    if($(el).parents('.lp-password-check').length > 0 ){
                        
                        let regex = /^(?=(?:.*?[A-Z]){0})(?=(?:.*?[0-9]){1})(?=(?:.*?[!@#$%*()_+^&}{:;?.]){0})(?!.*\s)[0-9a-zA-Z!@#$%;*(){}_+^&]*$/; 

                        if(el.value == "" || el.value == null ){
                            // $(el).addClass('lp-form-error');
                            $(el).parents('.-form-group').addClass('lp-form-error');
                            if(!is_cf7){
                                $(el).parents('.-form-group').find('.lp-error .form-error-text').html('Esse campo é obrigatório');
                            }
                            error = true
                        }else{
                            if($(el).hasClass('new-password') ){
                                if(el.value.length < 8){
                                    // $(el).addClass('lp-form-error');
                                    $(el).parents('.-form-group').addClass('lp-form-error');
                                    $(el).parents('.-form-group').find('.lp-error .form-error-text').html('A senha deve conter no minímo 8 digitos!');
                                    error = true;
                                }else if(el.value.replace(/\D/g, "").length == 0 || el.value.replace(/\D/g, "").length == el.value.length){
                                    // $(el).addClass('lp-form-error');
                                    $(el).parents('.-form-group').addClass('lp-form-error');
                                    $(el).parents('.-form-group').find('.lp-error .form-error-text').html('A senha deve conter no mínimo 1 número e 1 letra');
                                    error = true;

                                }
                            }else if($(el).hasClass('verify-password')){

                                if(el.value != $(el).parents('.lp-password-check').find('.new-password').val()){
                                    // $(el).addClass('lp-form-error');
                                    $(el).parents('.-form-group').addClass('lp-form-error');
                                    $(el).parents('.-form-group').find('.lp-error .form-error-text').html('Esse campo deve ser igual a nova senha');
                                    error = true;

                                }
                            }
                        }


                    }else if(el.type == 'checkbox'){
                        /*if($(el).hasClass('required') && $(el).parents('form').find('input[name="'+el.name+'"]:checked').length < 1){
                            // $(el).addClass('lp-form-error');
                            $(el).parents('.-form-group').addClass('lp-form-error');
                            if(!is_cf7){
                                $(el).parents('.-form-group').find('.lp-error .form-error-text').html('Esse campo é obrigatório');
                            }
                            error = true;
                        }*/
                        if( $(el).parents('form').find('input[name="'+el.name+'"]:checked').length < 1){
                            // $(el).addClass('lp-form-error');
                            $(el).parents('.-form-group').addClass('lp-form-error');
                            if(!is_cf7){
                                $(el).parents('.-form-group').find('.lp-error .form-error-text').html('Esse campo é obrigatório');
                            }
                            error = true;
                        }
                    }else if(el.type == 'radio'){
                        /*if($(el).hasClass('required') && $(el).parents('form').find('input[name="'+el.name+'"]:checked').length < 1){
                            // $(el).addClass('lp-form-error');
                            $(el).parents('.-form-group').addClass('lp-form-error');
                            if(!is_cf7){
                                $(el).parents('.-form-group').find('.lp-error .form-error-text').html('Esse campo é obrigatório');
                            }
                            error = true;
                        }*/
                        if( $(el).parents('form').find('input[name="'+el.name+'"]:checked').length < 1){
                            // $(el).addClass('lp-form-error');
                            $(el).parents('.-form-group').addClass('lp-form-error');
                            if(!is_cf7){
                                $(el).parents('.-form-group').find('.lp-error .form-error-text').html('Esse campo é obrigatório');
                            }
                            error = true;
                        }
                    }else{
                        if(el.value == "" || el.value == null ){
                            // $(el).addClass('lp-form-error');
                            $(el).parents('.-form-group').addClass('lp-form-error');
                            if(!is_cf7){
                                $(el).parents('.-form-group').find('.lp-error .form-error-text').html('Esse campo é obrigatório');
                            }
                            error = true;
                        }else if($(el).hasClass('mask-cpf')){
                            if(!validate_cpf(el.value)){
                                $(el).parents('.-form-group').addClass('lp-form-error');
                                if(!is_cf7){
                                    $(el).parents('.-form-group').find('.lp-error .form-error-text').html('Precisa ser um CPF válido.');
                                }
                                error = true;
                            }
                        }
                    }
                }else{
                    // $(el).removeClass('lp-form-error');
                    $(el).parents('.-form-group').removeClass('lp-form-error');
                    if(!is_cf7){
                        $(el).parents('.-form-group').find('.lp-error .form-error-text').html('');
                    }
                }
            }

        });

        textareas.each(function(index, el) {
            if($(el).hasClass('.no-validate') || $(el).parents('.no-validate').length > 0){

            }else{
                if(el.value == "" || el.value == null ){
                    // $(el).addClass('lp-form-error');
                    $(el).parents('.-form-group').addClass('lp-form-error');
                    if(!is_cf7){
                        $(el).parents('.-form-group').find('.lp-error .form-error-text').html('Esse campo é obrigatório');
                    }
                    error = true
                }
            }
        });

        selects.each(function(index, el) {

            if($(el).hasClass('.no-validate') || $(el).parents('.no-validate').length > 0){

            }else{

                if(el.value == "" || el.value == null || el.value == "Assunto" || el.value == "Cidade" ){
                    // $(el).addClass('lp-form-error');
                    $(el).parents('.-form-group').addClass('lp-form-error');
                    if(!is_cf7){
                        $(el).parents('.-form-group').find('.lp-error .form-error-text').html('Esse campo é obrigatório');
                    }
                    error = true
                }
            }
        });




        if(error){
            event.preventDefault();
        }else{
            dataLayer.push({'event': 'cadastro_lp_club_essence'});
        }
    });

    


    $("form").each(function(event) {
        var inputs = $(this).find('input');
        var textareas = $(this).find('textarea');
        var selects = $(this).find('select');
        var icons = $(this).find('.lp-input-icon-content .input-icon');

        

        inputs.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null ){
                    if(el.type == 'file' && $(el).parents('.-form-group').hasClass('lp-form-error-file')){

                    }else{

                        $(el).removeClass('lp-form-error');
                        $(el).removeClass('wpcf7-not-valid');
                        $(el).parents('.-form-group').removeClass('lp-form-error');
                        $(el).parents('.-form-group').find('.lp-error .form-error-text').html('');
                        $(el).parent().find('.wpcf7-not-valid-tip').remove();
                    }
                }
            });
            
        });

        textareas.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null ){
                    $(el).removeClass('lp-form-error');
                    $(el).removeClass('wpcf7-not-valid');
                    $(el).parents('.-form-group').removeClass('lp-form-error');
                    $(el).parents('.-form-group').find('.lp-error .form-error-text').html('');
                    $(el).parent().find('.wpcf7-not-valid-tip').remove();
                }
            });
        });

        selects.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null && el.value != "UF" && el.value != "Cidade" ){
                    $(el).removeClass('lp-form-error');
                    $(el).removeClass('wpcf7-not-valid');
                    $(el).parents('.-form-group').removeClass('lp-form-error');
                    $(el).parents('.-form-group').find('.lp-error .form-error-text').html('');
                    $(el).parents('.-form-group-container').find('.wpcf7-not-valid-tip').remove();
                }
            });
        });

        icons.each(function(index, el) {

            $(el).click(function(event) {
                let input_type = $(this).data('input-type');
                let icon_class = $(this).data('icon-class');

                if(input_type && input_type != ''){
                    $(this).data('input-type', $(this).parents('.-form-group').find('.lp-input').attr('type'));
                    $(this).parents('.-form-group').find('.lp-input').attr({
                        'type': input_type,
                    });
                }
                if(icon_class && icon_class != ''){
                    $(this).data('icon-class', this.className);
                    $(this).attr('class', icon_class);
                }
                
            });

        });

    });


    // $("form.course-filter-form").each(function(index, el) {
    //     let form = $(el);
    //     form.find('input').change(function(event) {
    //         form.submit();
    //     });
    // });





    $("form.wpcf7-form").submit(function(event) {
        $(this).find('input[type=submit]').attr({ disabled: '' });
        $(this).addClass('loading');
    });


    //Function to redirect form after submit
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        var link = $(event.srcElement).parents('[data-thanks-link]').data('thanks-link');

        $(event.srcElement).find('[type=submit]').addClass('successful');
        $(event.srcElement).find('[type=submit]').prop("disabled",false);

        setTimeout(function(){
            $(event.srcElement).find('[type=submit]').removeClass('successful');
        },10000);
        if(link){
            // setTimeout(function(){
            //     location = link;
            // },5000);
            location = link;
        }

    }, false );
    //End
    
    
    



    window.addEventListener('scroll', function(e) {
        if(!is_ie() && ($(window).innerWidth() > 767)){
            var position = window.scrollY || window.pageYOffset || document.body.scrollTop;
            var windowH = window.innerHeight;

        }
    });


    $('[custom-modal-id]').click(function(event) {
        if($('#'+$(this).attr('custom-modal-id')).length > 0){
            $('body').addClass('custom-modal-active');
            $('body').addClass('no-scroll');
            $('#'+$(this).attr('custom-modal-id')).addClass('active');
            $('#'+$(this).attr('custom-modal-id')).trigger( "modal_open" );

        }
    });

    


    


    $('.lp-custom-modal-bg, .lp-custom-modal-close').click(function(event) {
        setTimeout(function(){
            $('body').removeClass('custom-modal-active');
            $('body').removeClass('no-scroll');
        },300);
        $('.lp-custom-modal').removeClass('active');
        $('.lp-custom-modal').trigger( "modal_close" );
    });


    $('.change-content-modal-btn').click(function(event) {
        $('#change-content-modal .modal-title').html($(this).data('title'));
        $('#change-content-modal .custom-modal-body').html($(this).find('.text').html());
    });

    $('.iframe-modal-btn').click(function(event) {
        $('#iframe-modal .modal-iframe').attr('src',$(this).data('iframe-link'));
    });
    $('#iframe-modal .modal-iframe').on( 'load',function() {
        if($(this).attr('src') != ''){
            $(this).addClass('-loaded');
        }
    });

    $('#iframe-modal').on('modal_close', function(event) {
        $('#iframe-modal .modal-iframe').attr('src','');
        $('#iframe-modal .modal-iframe').removeClass('-loaded');
    });





    if($('.lp-cookie-alert').length > 0){

        var ucr_rolamentos_cookie_alert = $('.lp-cookie-alert')[0];
        var wp_ucr_rolamentos_cookie = readCookie('wp_ucr_rolamentos_cookie');
        if(wp_ucr_rolamentos_cookie && wp_ucr_rolamentos_cookie == 'true'){

        }else{
            $(ucr_rolamentos_cookie_alert).addClass('active');
            
            $(ucr_rolamentos_cookie_alert).find('.lp-cookie-alert-accept').click(function(event) {
                createCookie('wp_ucr_rolamentos_cookie', 'true', 365);
                $(ucr_rolamentos_cookie_alert).removeClass('active');
            });

            $(ucr_rolamentos_cookie_alert).find('.hide-cookie-alert').click(function(event) {
                $(ucr_rolamentos_cookie_alert).removeClass('active');
            });

        }
    }



    $('.lp-gallery-container').each(function(index, el) {
        let container = $(el);

        container.lightGallery({
            selector: '.gallery-item',
            download: false,
            addClass: 'gl-work-gallery-item',
            thumbnail: true,
        });
    });


    $('.lp-cards-list.-certificates-gallery').each(function(index, el) {
        let container = $(el);

        container.lightGallery({
            selector: '.lp-card.-certificates:not(.-btns)',
            download: false,
            addClass: 'gl-card-gallery-item',
            thumbnail: true,
        });
    });

    $('.lp-home-gallery .gallery-list').each(function(index, el) {
        let container = $(el);

        container.lightGallery({
            selector: '.gallery-item',
            download: false,
            addClass: 'gl-home-gallery-item',
            thumbnail: true,
        });
    });

    $('.lp-gallery-list').each(function(index, el) {
        let container = $(el);

        container.lightGallery({
            selector: '.gallery-item',
            download: false,
            addClass: 'gl-home-gallery-item',
            thumbnail: true,
        });
    });


    
    
    function table_has_scrollable(){
        $('.lp-table-container .lp-table-scroll').each(function(index, el) {
            if(el.scrollWidth > el.clientWidth){
                $(el).parents('.lp-table-container').addClass('-has-scrollable');
            }else{
                $(el).parents('.lp-table-container').removeClass('-has-scrollable');
            }
        });
    }

    window.addEventListener('resize', function(event){
        table_has_scrollable();
    });
    table_has_scrollable();

    $('.lp-table-container .lp-table-scroll-icon').click(function(event) {
        var root = $(this).parents('.lp-table-container').find('.lp-table-scroll');
        var scrLeft = root[0].scrollWidth - root[0].clientWidth;

        if(root.scrollLeft() >= scrLeft - 5){
            scrLeft = 0;
        }

        root.animate({scrollLeft: scrLeft}, 800);

    });


    $('.search-form-filter-btn').click(function(event) {
        if($(this).hasClass('-active')){
            $(this).removeClass('-active');
            $('.search-form-filter').removeClass('-active');
        }else{
            $(this).addClass('-active');
            $('.search-form-filter').addClass('-active');
        }

    });


    $('.filter-container .filter-item-btn').click(function(event) {
        $(this).parents('.filter-item').toggleClass('-show');
    });
    $(document).click(function(event) {
        $('.filter-container .filter-item').each(function(index, el) {
            if($(event.target).parents('.filter-item').length > 0){
                if($(event.target).parents('.filter-item')[0] != el){
                    $(el).removeClass('-show');
                }
            }else{

                $(el).removeClass('-show');
            }
        });
    });


    window.addEventListener('scroll', function(e) {
        $('.lp-img-resize').each(function(index, el) {
            el.img = $(el).find('img');
            let positions = el.getBoundingClientRect();
            if(
                positions.top < (window.innerHeight - (el.img.innerHeight() * 0.25))
                && positions.bottom > (0 + (el.img.innerHeight() * 0.25))
            ){
                let total = window.innerHeight + (el.img.innerHeight() * 0.5);
                let current = (window.innerHeight - (el.img.innerHeight() * 0.25)) - positions.top;
                el.img.css('--resize',(1 + (current / total / 10)));
            }
        });
    });



    $('.lp-customers-list').slick({
        dots: false,
        infinite: true,
        speed: 600,
        autoplay: true,
        autoplaySpeed: 1000,
        slidesToShow: 10,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 6,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 5,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 4,
            }
        }
        ]
    });


    $('.-accordion-btn').click(function(event) {
        $(this).parent().toggleClass('open');
    });


    $('.lp-points-container .lp-points-list .lp-points-item, .lp-points-container svg .points-item').mouseenter(function(event) {
        $(this).addClass('-hover');
        if($(this).data('item')){
            $('.lp-points-container .lp-points-list .lp-points-item[data-item="'+$(this).data('item')+'"], .lp-points-container svg .points-item[data-item="'+$(this).data('item')+'"]').addClass('-hover');
        }
    });

    $('.lp-points-container .lp-points-list .lp-points-item, .lp-points-container svg .points-item').mouseleave(function(event) {
        $(this).removeClass('-hover');
        if($(this).data('item')){
            $('.lp-points-container .lp-points-list .lp-points-item[data-item="'+$(this).data('item')+'"], .lp-points-container svg .points-item[data-item="'+$(this).data('item')+'"]').removeClass('-hover');
        }
    });

    $('[field-condition]').each(function(index, el) {
        var j = $(el).attr('field-condition');
        el.condition_fields = [];
        el.validate_conditions = function(){
            var show = true;
            this.condition_fields.forEach( function(e, i) {
                if(e['field'].val() != e['value']){
                    show = false;
                }
            });
            if(show){
                $(this).removeClass('no-validate');
                $(this).removeClass('hide');
            }else{
                $(this).addClass('hide');
                $(this).addClass('no-validate');
                $(this).removeClass('lp-form-error');
            }
        };


        if(isJson(j)){
            var list = JSON.parse(j);

            if(list.length > 0){
                list.forEach( function(e, i) {
                    console.log(e);
                    if(e.field && $(e.field).length > 0){
                        el.condition_fields.push({field:$(e.field),value:e.value});
                    }
                });
            }
        }

        el.condition_fields.forEach( function(e, i) {
            e['field'].change(function(event) {
                el.validate_conditions();
            });
        });

        el.validate_conditions();


    });


    
}(window.jQuery, window, document));